module.exports = __webpack_public_path__ + "img/AnnaiInsta_Final.fc61074b.jpg";